import React from 'react';
import '@questlabs/react-sdk/dist/style.css'; // Required by system instructions
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Hero from './components/home/Hero';
import Services from './components/home/Services';
import Advantages from './components/home/Advantages';
import Gallery from './components/home/Gallery';
import WhatsAppWidget from './components/widgets/WhatsAppWidget';
import BookingModal from './components/widgets/BookingModal';

function App() {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-primary selection:text-white">
      <Navbar />
      
      <main>
        <Hero />
        <Services />
        <Advantages />
        <Gallery />
      </main>

      <Footer />
      <WhatsAppWidget />
      <BookingModal />
    </div>
  );
}

export default App;